var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMindmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.33333C4 6.59694 4.59694 6 5.33333 6H7.99998C8.73609 6 9.33331 6.59694 9.33331 7.33333V7.77777H14.6666V7.33333C14.6666 6.59694 15.2638 6 15.9999 6H18.6666C19.4027 6 19.9999 6.59694 19.9999 7.33333V9.99998C19.9999 10.7361 19.4027 11.3333 18.6666 11.3333H15.9999C15.2638 11.3333 14.6666 10.7361 14.6666 9.99998V9.55554H9.33331V9.99998C9.33331 10.0472 9.33053 10.0944 9.32497 10.1139L11.5555 13.1111H14.2222C14.9583 13.1111 15.5555 13.7083 15.5555 14.4444V17.1111C15.5555 17.8472 14.9583 18.4444 14.2222 18.4444H11.5555C10.8194 18.4444 10.2222 17.8472 10.2222 17.1111V14.4444C10.2222 14.3972 10.225 14.35 10.2305 14.3055L7.99998 11.3333H5.33333C4.59694 11.3333 4 10.7361 4 9.99998V7.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindmap);
export default __webpack_public_path__ + "static/media/mindmap.3c7e7bd5e0aa1111a3a157e605c106d8.svg";
export { ForwardRef as ReactComponent };